import React, { useEffect, useState } from 'react';
import { sha256 } from 'js-sha256';
import { baseUrl_SPB, hostNameNoWWW, hostNameWithHTTP } from '../../BaseUrl';

const CLIENT_ID = 'B88B2D3D164B43D093D824E670BD901D';
const REDIRECT_URI = `${hostNameWithHTTP}/xero/callback`; // Make sure this matches your registered URI'
console.log('REDIRECT_URI:', REDIRECT_URI);
const BACKEND_CALLBACK_URL = `${baseUrl_SPB}/api/v1/xero/connect/callback`;
const SCOPES = 'openid profile email accounting.transactions accounting.settings payroll.settings payroll.settings.read payroll.employees payroll.timesheets offline_access';

const generateRandomBytes = (length) => {
  const array = new Uint8Array(length);
  window.crypto.getRandomValues(array);
  return array;
};

const bufferToBase64 = (buffer) => {
  return btoa(String.fromCharCode(...buffer));
};

const base64UrlEncode = (str) =>
  str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

export default function XeroPKCEScreen() {
  const [codeVerifier, setCodeVerifier] = useState('');
  const [authUrl, setAuthUrl] = useState('');

  useEffect(() => {
    const generatePKCE = () => {
      // 1. Generate code verifier
      const randomBytes = generateRandomBytes(32);
      const base64Verifier = bufferToBase64(randomBytes);
      const verifier = base64UrlEncode(base64Verifier);
      setCodeVerifier(verifier);
      sessionStorage.setItem('xero_code_verifier', verifier); // Save verifier for use after redirect

      // 2. Generate code challenge from verifier
      const hashBytes = sha256.array(verifier); // Uint8Array
      const base64Hash = bufferToBase64(hashBytes);
      const challenge = base64UrlEncode(base64Hash);

      // 3. Construct Xero auth URL
      const url =
        `https://login.xero.com/identity/connect/authorize?` +
        `response_type=code&client_id=${CLIENT_ID}` +
        `&redirect_uri=${encodeURIComponent(REDIRECT_URI)}` +
        `&scope=${encodeURIComponent(SCOPES)}` +
        `&code_challenge=${challenge}&code_challenge_method=S256`;

      setAuthUrl(url);
    };

    generatePKCE();
  }, []);

  const handleLogin = () => {
    if (authUrl) {
      window.location.href = authUrl; // Redirect to Xero login
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Xero OAuth with PKCE</h2>
      <button onClick={handleLogin} disabled={!authUrl}>
        Connect to Xero
      </button>
    </div>
  );
}
